const ContactMedia = () =>
  import(
    /* webpackChunkName: "base-info-crm-contact-media" */ '@/pages/base-info/crm/contact-media/index.vue'
  )
const CreateContactMedia = () =>
  import(
    /* webpackChunkName: "base-info-crm-contact-media" */ '@/pages/base-info/crm/contact-media/create.vue'
  )
const EditContactMedia = () =>
  import(
    /* webpackChunkName: "base-info-crm-contact-media" */ '@/pages/base-info/crm/contact-media/edit.vue'
  )

export default {
  path: 'contact-media',
  meta: {
    label: 'media',
    auth: 'media'
  },
  component: {
    name: 'Media',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'BaseInfoCrmContactMedia',
      path: '/',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: ContactMedia
    },
    {
      name: 'BaseInfoCreateCrmContactMedia',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateContactMedia
    },
    {
      name: 'BaseInfoEditCrmContactMedia',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditContactMedia,
      props: true
    }
  ]
}
